import "./Project1.css";
function Project7() {
  return (
    <div className="project1-cont active">
      <div className="project-header">
        <h2>JB Commercial</h2>
      </div>
      <div className="about-text">
        <p>
          JB Commercial is a bespoke e-commerce WordPress theme with a variety of custom blocks, developed for a furniture company specializing in commercial interiors. The website features a sleek and user-friendly interface, offering potential customers an immersive browsing and shopping experience. The project was implemented using PHP, ACF, WooCommerce, CSS, SASS, WordPress, JavaScript, and jQuery.
          <br/>
          JB Commercial was developed under the expert supervision and creative direction of Up Hotel Agency & ADAO.
        </p>
        <h3 className="project-link">
          <a
            href="https://www.jb-commercial-furniture.co.uk/"
            target="_blank"
            rel="noreferrer"
          >
            <span>View Site</span>
          </a>
          <br />
        </h3>
      </div>
    </div>
  );
}

export default Project7;
